/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { Fragment } from 'react';
import FormGroup from '@material-ui/core/FormGroup';
import { Typography } from '@material-ui/core';
import {
  renderTaggedPrintNotes,
  renderFormAddons,
} from '@mummssoftware/common-ui';
import { formatLocDateMMDDYYYY } from '@mummssoftware/utils/formatters';
import {
  doNotDisplayText,
  getReadOnlyInputText,
  isSubqchoice,
  updateStructure,
} from '@mummssoftware/utils/form-engine/form-engine-utils';
import { PainMapReadOnly } from './PainMapReadOnly';
import { FormSignature } from './FormSignature';

/**
 * FORMS SPECIFIC ELEMENTS
 */
import {
  horizontal,
  statement,
  label,
  input,
  date,
  signature,
  singleselect,
  multiselect,
  map,
} from './constants';
import {
  FormBody,
  StyledLi,
  StyledReadOnlyUl,
  DCDiv,
  FormLi,
  StyledDiv,
  InputDiv,
  ElementDiv,
} from './WrapperDiv';
import { useStyles } from './style';
import { ReadLabelField, ReadOnlyStatementField } from './Field';
import {
  updateWhoStructure,
  getReadOnlySelectText,
  createGolbalLabelState,
  cleanFormSubmission,
} from './utils';
import defaults from '../../../translations/en.json';

type ReadOnlyFormProps = {
  // we are passing the formsubmission of the API get CPP by id
  formData: any;
  title?: string | null;
  printView?: boolean;
  pnNotes?: null | any[];
  dialogHeight?: boolean;
  formaddons?: any | null;
};

export const ReadOnlyForm = ({
  formData,
  pnNotes,
  title,
  printView,
  dialogHeight,
  formaddons,
}: ReadOnlyFormProps) => {
  const classes = useStyles();
  const readOnlyData = cleanFormSubmission(formData);

  let parsedData: any;
  // catch JSON parse exceptions

  try {
    parsedData = readOnlyData && JSON.parse(readOnlyData);
  } catch (e) {
    // TODO alert
    console.log('JSON PARSING ERROR', e);
  }

  const updateddata =
    parsedData && parsedData[0] ? updateStructure(parsedData) : undefined;
  const updatedData =
    updateddata && updateddata[0] ? updateWhoStructure(updateddata) : undefined;
  // console.log('***ReadOnlyForm updatedData***', updatedData);

  // this is for the goal will be achieved within
  const labelState = updatedData && createGolbalLabelState(updatedData);

  // @note empty Read Only are updatedData = [null]

  const renderField = (
    subqchoice: any,
    subMenu: any,
    // eslint-disable-next-line consistent-return
  ) => {
    switch (subqchoice.controltype) {
      case label:
        return (
          <div
            key={`label-${subqchoice.id}-${subqchoice.questionpath}`}
            id="read-only-label"
          >
            <FormLi
              key={`li-${subqchoice.id}-${subqchoice.questionpath}`}
              horizontal={subqchoice.drawmode === horizontal}
            >
              <ReadLabelField
                key={`field-${subqchoice.id}-${subqchoice.questionpath}`}
                subqchoice={subqchoice}
                isExpanded={isSubqchoice(subqchoice)}
              />
              {subMenu}
            </FormLi>
          </div>
        );
      case input: {
        return (
          <InputDiv
            key={`input-${subqchoice.id}-${subqchoice.questionpath}`}
            id="read-only-input"
          >
            <StyledDiv key={`li-${subqchoice.id}-${subqchoice.questionpath}`}>
              {doNotDisplayText(subqchoice)
                ? ''
                : getReadOnlyInputText(subqchoice)}
              {subMenu}
            </StyledDiv>
          </InputDiv>
        );
      }
      case singleselect:
      case multiselect: {
        return subqchoice.overwritedrawmode ? (
          <div
            key={`checkbox-${subqchoice.parentquestionpath}-${subqchoice.id}`}
            id="read-only-select"
          >
            <StyledLi
              key={`li-${subqchoice.id}-${subqchoice.questionpath}`}
              dc={!!subqchoice.dcdate}
            >
              {isSubqchoice(subqchoice) && subqchoice.questionlabel}
              {subMenu}
            </StyledLi>
          </div>
        ) : (
          <div
            key={`checkbox-${subqchoice.parentquestionpath}-${subqchoice.id}-${subqchoice.questionpath}`}
            id="read-only-select"
          >
            <StyledDiv
              key={`li-${subqchoice.id}-${subqchoice.questionpath}`}
              dc={!!subqchoice.dcdate}
              horizontal={subqchoice.drawmode === horizontal}
            >
              {isSubqchoice(subqchoice) &&
                getReadOnlySelectText(subqchoice, labelState)}
              {subMenu}
            </StyledDiv>
          </div>
        );
      }
      // FORMS components
      case statement:
        return (
          <ElementDiv key={`list-${subqchoice.id}`} id="cpp-statement">
            <FormLi
              key={`li-${subqchoice.id}`}
              id="cpp-li-statement"
              horizontal={subqchoice.drawmode === horizontal}
              bullet={subqchoice.cssclass === 'bullet'}
              readOnly
            >
              <ReadOnlyStatementField
                key={`field-${subqchoice.id}`}
                title={subqchoice.cssclass}
                text={subqchoice.questionlabel}
              />
              {subMenu}
            </FormLi>
          </ElementDiv>
        );
      case date:
        return (
          <ElementDiv key={`list-${subqchoice.id}`} id="cpp-statement">
            <FormLi
              key={`li-${subqchoice.id}`}
              id="cpp-li-statement"
              horizontal={subqchoice.drawmode === horizontal}
              readOnly
            >
              <ReadOnlyStatementField
                key={`field-${subqchoice.id}`}
                text={`${formatLocDateMMDDYYYY(subqchoice.value)} (${
                  subqchoice.questionlabel
                })`}
              />
              {subMenu}
            </FormLi>
          </ElementDiv>
        );
      case signature:
        return (
          <div
            key={`input-${subqchoice.id}-${subqchoice.questionpath}`}
            id="read-only-input"
          >
            <FormSignature
              readOnly
              subqchoice={subqchoice}
              handleValidate={undefined}
              handleClear={undefined}
            />
          </div>
        );
      case map:
        return (
          <div
            key={`input-${subqchoice.id}-${subqchoice.questionpath}`}
            id="read-only-pain"
          >
            <PainMapReadOnly subqchoice={subqchoice} />
          </div>
        );
      // case checkbox, radio and null:
      default: {
        const {
          modifiedpersonfirstname,
          modifiedpersonlastname,
          modifiedpersoncredentials,
        } = subqchoice;
        const credential =
          modifiedpersonfirstname &&
          `${modifiedpersonfirstname} ${modifiedpersonlastname}, ${modifiedpersoncredentials}`;
        const textLabel = subqchoice.questionlabel;

        return (
          <div
            key={`checkbox-${subqchoice.parentquestionpath}-${subqchoice.id}-${subqchoice.questionpath}`}
            id="read-only-default"
          >
            <StyledLi
              key={`li-${subqchoice.id}-${subqchoice.questionpath}`}
              dc={!!subqchoice.dcdate}
              noBullet={subqchoice.readonlydrawmode}
              horizontal={
                subqchoice.drawmode === horizontal &&
                !subqchoice.readonlydrawmode
              }
            >
              <>
                {!subqchoice.readonlydrawmode && (
                  <>{isSubqchoice(subqchoice) && textLabel}</>
                )}
                {subqchoice.dcdate && (
                  <DCDiv>
                    <div>{textLabel}</div>
                    <div>
                      {credential
                        ? `DC'd on ${subqchoice.dcdate} by
                  ${credential}`
                        : `DC'd on ${subqchoice.dcdate}`}
                    </div>
                  </DCDiv>
                )}
              </>

              {subMenu}
            </StyledLi>
          </div>
        );
      }
    }
  };

  const renderSubMenu = (
    subqchoices: any,
    depthLevel = 0,
    isHorizontal?: boolean,
  ) => {
    const menuOptions = subqchoices.map((subqchoice: any) => {
      const hasOptions =
        subqchoice.subqchoices &&
        subqchoice.subqchoices.length > 0 &&
        subqchoice.subqchoices[0] !== null;

      let subMenu;
      const isStatement = subqchoice.controltype === statement;
      const hasValue =
        depthLevel === 0 || isStatement ? true : isSubqchoice(subqchoice);
      const isHorizontalMode = subqchoice.drawmode === horizontal;

      // only render selected submenu and only if nested options exist

      if (hasValue && hasOptions) {
        const newDepthLevel = depthLevel + 1;

        const subChoices = subqchoice.subqchoices.filter(
          (choice: any) =>
            choice.dcdate ||
            choice.controltype === statement ||
            (choice.value !== 'false' && choice.value !== null),
        );

        subMenu = renderSubMenu(subChoices, newDepthLevel, isHorizontalMode);
      }

      return renderField(subqchoice, subMenu);
    });

    // TO KNOW The <ul> tag has a default padding-inline-start of 40px

    return (
      <div key={`div-key-${depthLevel}`}>
        <FormGroup>
          <StyledReadOnlyUl id="read-only-ul" horizontal={isHorizontal}>
            {menuOptions}
          </StyledReadOnlyUl>
        </FormGroup>
      </div>
    );
  };

  return (
    <FormBody id="read-only" printView={printView} dialogHeight={dialogHeight}>
      {title && (
        <Typography
          variant="body1"
          classes={
            printView
              ? {
                  root: classes.printTitle,
                }
              : {}
          }
        >
          {title}
        </Typography>
      )}
      <Fragment>
        {updatedData && updatedData[0] && renderSubMenu(updatedData)}
        {!updatedData && <div>{defaults.errorDisplay}</div>}
      </Fragment>
      <Fragment>
        {formaddons && renderFormAddons(formaddons)}
        {pnNotes && renderTaggedPrintNotes(pnNotes, defaults.relatedNotes)}
      </Fragment>
    </FormBody>
  );
};

export default ReadOnlyForm;
